import './WebChatPluginButton.scss';
import IconButton from '@mui/material/IconButton';
import ChatIcon from '@mui/icons-material/Chat';
import Tooltip from '@mui/material/Tooltip';

export function WebChatPluginButton({
  onClick,
  webChatConfiguration,
  hideTooltip,
}) {
  const shape = webChatConfiguration?.chat_button_icon_shape ?? 'circle';
  const borderRadius =
    shape === 'circle' ? '50%' : shape === 'rounded' ? '12px' : '4px';

  return (
    <div className="prospera-web-chat-plugin-button">
      <Tooltip
        open={!hideTooltip && webChatConfiguration?.show_chat_button_callout}
        title={webChatConfiguration.chat_button_callout_text}
        placement={'top-start'}
        classes={{ tooltip: 'prospera-web-chat-button-tooltip' }}
      >
        <IconButton
          aria-label="chat-with-bot"
          style={{
            width: 64,
            height: 64,
            borderRadius,
            backgroundColor:
              webChatConfiguration?.chat_button_color || '#0041ed',
          }}
          onClick={onClick}
        >
          {webChatConfiguration?.chat_button_icon_image_url ? (
            <img
              src={webChatConfiguration?.chat_button_icon_image_url}
              alt={
                webChatConfiguration?.chat_button_callout_text ||
                'Chat with the Bot'
              }
              style={{
                width: 48,
                height: 48,
                borderRadius,
                objectFit: 'cover',
              }}
            />
          ) : (
            <ChatIcon fontSize="inherit" sx={{ fontSize: 32 }} />
          )}
          <div className={'hover-overlay'} style={{ borderRadius }}></div>
        </IconButton>
      </Tooltip>
    </div>
  );
}
